import Config from "../config/Config";
const publicVapidKey = 'BN9k-wUYcE3X1jR9Ur9sMQfhvrhQ2JuD8OMn4HWqiADEzR5CW7F0qr4tS8r_f1fgUVJkxigWs_9yvx8_ILGuglY';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding)
    .replace(/\-/g, '+')
    .replace(/_/g, '/');

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export async function subscribeUserToPush(userId) {
  if (!userId) {
    console.warn('Cannot subscribe to push notifications: userId is missing.');
    return;
  }

  if (!('serviceWorker' in navigator)) {
    console.warn('Service Worker not supported');
    return;
  }
  if (!('PushManager' in window)) {
    console.warn('Push API not supported');
    return;
  }

  try {
    const registration = await navigator.serviceWorker.ready;
    const subscription = await registration.pushManager.getSubscription();

    if (subscription) {
      console.log('User is already subscribed:', subscription);
      await sendSubscriptionToBackend(subscription, userId);
      return subscription;
    }

    const applicationServerKey = urlBase64ToUint8Array(publicVapidKey);
    const newSubscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: applicationServerKey
    });

    console.log('User subscribed:', newSubscription);
    await sendSubscriptionToBackend(newSubscription, userId);
    return newSubscription;

  } catch (error) {
    console.error('Failed to subscribe the user:', error);
  }
}

async function sendSubscriptionToBackend(subscription, userId) {
  const response = await fetch(`${Config.localApi}notification/subscribe`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ subscription, userId }),
  });

  if (!response.ok) {
    throw new Error('Failed to send subscription to backend');
  }

  console.log('Subscription sent to backend successfully.');
}

export async function unsubscribeUserFromPush(userId) {
  if (!('serviceWorker' in navigator)) {
    console.warn('Service Worker not supported');
    return;
  }
  if (!('PushManager' in window)) {
    console.warn('Push API not supported');
    return;
  }

  try {
    const registration = await navigator.serviceWorker.ready;
    const subscription = await registration.pushManager.getSubscription();

    if (subscription) {
      await subscription.unsubscribe();
      console.log('User unsubscribed.');
      await removeSubscriptionFromBackend(subscription, userId);
    } else {
      console.log('User is not subscribed.');
    }
  } catch (error) {
    console.error('Failed to unsubscribe the user:', error);
  }
}

async function removeSubscriptionFromBackend(subscription, userId) {
  const response = await fetch(`${Config.localApi}notification/unsubscribe`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ endpoint: subscription.endpoint, userId }),
  });

  if (!response.ok) {
    throw new Error('Failed to remove subscription from backend');
  }

  console.log('Subscription removed from backend successfully.');
}
